import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute } from '@angular/router';
import { IDatasource, GridApi, GridOptions, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { UserPlatformGroupRoleDto, PlatformGroupRoleDto } from 'projects/shared/src/lib/models/PlatformGroupRoleDto';
import { TenantDto, UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { debounceTime, tap, switchMap, finalize } from 'rxjs';
import { AgGridTenantsSettings } from './AgGridTenantsSettings';
import { TenantButtonRendererComponent } from './tenant-button-renderer/tenant-button-renderer.component';

@Component({
  selector: 'tenant-info',
  templateUrl: './tenant-info.component.html',
  styleUrls: ['./tenant-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TenantInfoComponent implements OnInit {
  @Input('user') user!:UserDto;
  tenantGroupForm!:FormGroup;

  isLoading:boolean = false;
  totalRecords = 0;
  currentPage = 1;
  pageSize = 100;

  tenants:TenantDto[] = [];
  userTenants:UserTenantDto[] = [];

  rowData:UserTenantDto[] = [];
  rowDataAll:UserTenantDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridTenantsSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private tenantService:TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.filter = new GenericFilter();
    this.aggridSettings = new AgGridTenantsSettings(this.translate);

    this.frameworkComponents = {
      buttonRenderer: TenantButtonRendererComponent
    };

    this.gridOptions = this.aggridSettings.agGridTenantsSettings;

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'UserTenant';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        //this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;
        this.rowData = [];
        this.tenantService.getUserTenantz(this.user.id, this.filter).subscribe({
          next: (tenants) => {
            console.log("------> tenant-info-component: tenants=")
            console.log(tenants)
            this.rowDataAll = tenants.slice(this.filter.startRow, this.filter.endRow);
            tenants.forEach((rd: UserTenantDto) => {
            //this.rowDataAll.forEach((rd: UserTenantDto) => {
              if (rd.tenantName != "Basis") {
                this.rowData.push(rd);
              }
            });
            // console.log("------> tenant-info-component: tenants in rowData=")
            // console.log(this.rowData)

  
            let lastRow = -1;

            if (this.rowData.length <= this.filter.endRow) {
              lastRow = this.rowData.length;
            }
            params.successCallback(this.rowData, lastRow);

            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            this.resultsLength = this.rowData.length;

            this.gridApi.hideOverlay();

            //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERTENANTINFORETRIVED"]}`);
          },
          error: (error: any) => {
            this.isLoadingResults = false;
          // Catch if the Squirrel API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTINFORETRIVEDERROR"]}`)
          }
        });
      }
    };

   // this.createTenantGroupForm();
   // this.searchPlatformGroupRole();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();

    console.log("----> ds:")
    console.log(this.ds)
    this.gridApi.setDatasource(this.ds)
  }

  createTenantGroupForm() {

    this.tenantGroupForm = this.formBuilder.group({
      name:['',Validators.required]
    });
  }

  // searchPlatformGroupRole() {
  //   let searchText = this.tenantGroupForm.get('name')?.value;
  //     this.tenantService.fetchSubTenants(searchText, this.currentPage, this.pageSize).subscribe({
  //     next: (tenants) => {
  //       console.log(tenants)
  //       this.tenants = tenants;
  //     }
  //   });

  //   this.tenantGroupForm.get('name')?.valueChanges
  //   .pipe(debounceTime(300),
  //   tap(() => this.isLoading = true ), 
  //   switchMap((value: any) => this.tenantService.fetchSubTenants(value, this.currentPage, this.pageSize)
  //   .pipe(finalize(() => this.isLoading = false))))
  //   .subscribe({
  //     next:(data: any) => {
  //       this.tenants = data;
  //     },
  //     //error
  //   });
  // }

  onSelectionChanged(event: MatAutocompleteSelectedEvent){
    const selectedValue = event.option.value;

    let userTenant = new UserTenantDto
    userTenant.tenantId = selectedValue.id;
    userTenant.userId = this.user.id;
    userTenant.tenantName = selectedValue.name;

    console.log(selectedValue)
    console.log(userTenant)

    this.notificationService.error(`${this.translate.data["ERROR"]}`, `nicht implmentiert! (tenant-info)`)
    // this.tenantService.createUserTenancy(userTenant).subscribe({
    //   next:(tenantUser) => {
    //     this.rowData.splice(2,0,tenantUser);
    //     this.rowData.push(tenantUser);
    //     this.gridApi.refreshInfiniteCache();
    //     this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERADDEDTOTENANCY"]} : ${userTenant.tenantName}`);
    //   },
    //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDTOTENANCYERROR"]} - ${userTenant.tenantName}`)
    // })
  }

  displayFn(platformGroupRole: any) : any{
    if (platformGroupRole) { 
      return platformGroupRole.name; 
    }
  }

}
